module.exports = __webpack_public_path__ + "static/media/ever_pano_03-min.e57272bd.JPG";